var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-picture-editor"},[_c('the-picture-editor-crop',{staticClass:"the-picture-editor__source",attrs:{"fileName":_vm.fileName},on:{"preview":_vm.preview}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }